// extracted by mini-css-extract-plugin
export var content = "_4g-3";
export var list = "_4g-4";
export var settingsContent = "_4g-7";
export var settingsPanel = "_4g-8";
export var state = "_4g-6";
export var triggerBadge = "_4g-2";
export var triggerButton = "_4g-1";
export var triggerShell = "_4g-0";
export var unreadDot = "_4g-5";